export const REGEX = {
  INTERNATIONAL: /^(?![:-])[A-Za-zĄČĘĖĮŠŲŪŽąčęėįšųūž0-9/?:().,+'\s"-]*$/ as RegExp,
  CHAR_NUMBER_NO_SPACE: /^[A-Za-z0-9]*$/ as RegExp,
  CUSTOMER_CODE: /^(?=[^ :/-])[A-Za-z0-9/?:().,+'\s"-]*$/ as RegExp,
  ENDS_SLASH: /^(.*[^/])$/ as RegExp,
};
